"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var keys_1 = require("./keys");
var utils_1 = require("../utils");
var constants_1 = require("../constants");
var types_1 = require("../types");
function sign(msg, privateKey, charSize) {
    if (charSize === void 0) { charSize = constants_1.DEFAULT_CHAR_SIZE; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, globalThis.crypto.subtle.sign({ name: constants_1.RSA_WRITE_ALG, saltLength: constants_1.SALT_LENGTH }, privateKey, utils_1.normalizeUnicodeToBuf(msg, charSize))];
        });
    });
}
exports.sign = sign;
function verify(msg, sig, publicKey, charSize, hashAlg) {
    if (charSize === void 0) { charSize = constants_1.DEFAULT_CHAR_SIZE; }
    if (hashAlg === void 0) { hashAlg = constants_1.DEFAULT_HASH_ALG; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = globalThis.crypto.subtle).verify;
                    _c = [{ name: constants_1.RSA_WRITE_ALG, saltLength: constants_1.SALT_LENGTH }];
                    if (!(typeof publicKey === "string")) return [3 /*break*/, 2];
                    return [4 /*yield*/, keys_1.default.importPublicKey(publicKey, hashAlg, types_1.KeyUse.Write)];
                case 1:
                    _d = _e.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _d = publicKey;
                    _e.label = 3;
                case 3: return [2 /*return*/, _b.apply(_a, _c.concat([_d, utils_1.normalizeBase64ToBuf(sig),
                        utils_1.normalizeUnicodeToBuf(msg, charSize)]))];
            }
        });
    });
}
exports.verify = verify;
function encrypt(msg, publicKey, charSize, hashAlg) {
    if (charSize === void 0) { charSize = constants_1.DEFAULT_CHAR_SIZE; }
    if (hashAlg === void 0) { hashAlg = constants_1.DEFAULT_HASH_ALG; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = (_a = globalThis.crypto.subtle).encrypt;
                    _c = [{ name: constants_1.RSA_READ_ALG }];
                    if (!(typeof publicKey === "string")) return [3 /*break*/, 2];
                    return [4 /*yield*/, keys_1.default.importPublicKey(publicKey, hashAlg, types_1.KeyUse.Read)];
                case 1:
                    _d = _e.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _d = publicKey;
                    _e.label = 3;
                case 3: return [2 /*return*/, _b.apply(_a, _c.concat([_d, utils_1.normalizeUnicodeToBuf(msg, charSize)]))];
            }
        });
    });
}
exports.encrypt = encrypt;
function decrypt(msg, privateKey) {
    return __awaiter(this, void 0, void 0, function () {
        var normalized;
        return __generator(this, function (_a) {
            normalized = utils_1.normalizeBase64ToBuf(msg);
            return [2 /*return*/, globalThis.crypto.subtle.decrypt({ name: constants_1.RSA_READ_ALG }, privateKey, normalized)];
        });
    });
}
exports.decrypt = decrypt;
function getPublicKey(keypair) {
    return __awaiter(this, void 0, void 0, function () {
        var spki;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalThis.crypto.subtle.exportKey('spki', keypair.publicKey)];
                case 1:
                    spki = _a.sent();
                    return [2 /*return*/, utils_1.default.arrBufToBase64(spki)];
            }
        });
    });
}
exports.getPublicKey = getPublicKey;
exports.default = {
    sign: sign,
    verify: verify,
    encrypt: encrypt,
    decrypt: decrypt,
    getPublicKey: getPublicKey,
};
//# sourceMappingURL=operations.js.map